/**
 * D'où vient le concept que l'on ouvre en aperçu, en face à face ou en correspondance
 * (C23 SP1 à SP4, C26 SP4) : la note lisible qui porte la marque de son auteur, OU une
 * organisation dont je suis membre — jamais les deux, jamais aucune. Le type refuse un
 * appel qui ne dit ni l'un ni l'autre (sinon on appellerait `/notes//concepts/…`).
 */
export type SourceConcept =
    | { noteId: string; organisationId?: never }
    | { organisationId: string; noteId?: never };

/** Préfixe de la porte d'une organisation dans l'état des lectures : ne se confond jamais avec un identifiant de note. */
export const porteDOrganisation = (organisationId: string): string => `org:${organisationId}`;

/** La clé de porte d'une source, pour ranger et relire l'état d'un aperçu ou d'un face à face. */
export const porteDeSource = (source: SourceConcept): string =>
    source.organisationId !== undefined ? porteDOrganisation(source.organisationId) : source.noteId;

/** La source seule, extraite de props qui la portent parmi d'autres champs (pour la transmettre à un enfant). */
export const sourceDe = (source: SourceConcept): SourceConcept =>
    source.organisationId !== undefined ? { organisationId: source.organisationId } : { noteId: source.noteId };
